import { render, staticRenderFns } from "./mouldInfo.vue?vue&type=template&id=2a3a0c81&scoped=true&"
import script from "./mouldInfo.vue?vue&type=script&lang=js&"
export * from "./mouldInfo.vue?vue&type=script&lang=js&"
import style0 from "./mouldInfo.vue?vue&type=style&index=0&id=2a3a0c81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a0c81",
  null
  
)

export default component.exports